module.exports = __webpack_public_path__ + "static/media/sessionCheck.1ae2ac82.svg";